import { render, staticRenderFns } from "./addFormZhong.vue?vue&type=template&id=39fe99db&scoped=true&"
import script from "./addFormZhong.vue?vue&type=script&lang=js&"
export * from "./addFormZhong.vue?vue&type=script&lang=js&"
import style0 from "./addFormZhong.vue?vue&type=style&index=0&id=39fe99db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe99db",
  null
  
)

export default component.exports